var styles = {"box":"GroupAccordeon_box_1h4c9_1","title":"GroupAccordeon_title_1h4c9_6","list":"GroupAccordeon_list_1h4c9_31","list__item":"GroupAccordeon_list__item_1h4c9_36","open":"GroupAccordeon_open_1h4c9_43"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
